import React from 'react';
import { Divider } from 'antd';
import I18nCustomFormatter from 'Src/common/components/i18nCustomFormatter';

function NoResultsFound() {
  return (
    <div className="no-search-results-wrapper">
      <Divider>
        <span className="arc-support arc-color-gray7">
          <I18nCustomFormatter id="no-results-label" />
        </span>
      </Divider>
      <div className="no-search-results mb32">
        <img src={`${window.staticPath}img/mentorship/new/no-search-results.png`} alt="no search results found" />
        <h6 className="arc-H200 arc-color-gray8 mt12">
          <I18nCustomFormatter id="no-results-found-label" />
        </h6>
      </div>
    </div>
  );
}

export default NoResultsFound;
